module.exports = __webpack_public_path__ + "static/media/Muli-Bold.557f369c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli/Muli-Bold.ttf
// module id = 1296
// module chunks = 1